var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-image-holder"},[_c('div',{staticClass:"image-holder",on:{"click":function($event){return _vm.closeImageHolder()}}},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }